var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nineteen-ninety_nine-root" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `paddingTop:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.closeWeb },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow05.png"),
                      alt: "",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("div", { staticClass: "act-nine-con" }, [
      _c(
        "div",
        {
          staticClass: "bg-block",
          staticStyle: { "padding-top": "84px", "margin-top": "-84px" },
        },
        [
          _vm.$i18n.locale === "es"
            ? _c("img", {
                staticClass: "act-nine-tit",
                attrs: { src: require("./images/bg-tit3.png"), alt: "" },
              })
            : _vm.$i18n.locale === "pt"
            ? _c("img", {
                staticClass: "act-nine-tit",
                attrs: { src: require("./images/bg-tit2.png"), alt: "" },
              })
            : _c("img", {
                staticClass: "act-nine-tit",
                attrs: { src: require("./images/bg-tit1.png"), alt: "" },
              }),
          _c("div", { staticClass: "time-tips" }, [
            _c("img", {
              staticClass: "time-icon",
              attrs: { src: require("./images/clock.png"), alt: "" },
            }),
            _c("div", { staticClass: "tips-text" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("lang.commonM.k059")))]),
              _c("span", [_vm._v(_vm._s(_vm.actData.deadLine))]),
            ]),
          ]),
          _c("div", { staticClass: "act-nine-rules act-nine-rules1" }, [
            _c("div", { staticClass: "rules-left" }, [
              _c("img", {
                attrs: { src: require("./images/coins-2.png"), alt: "" },
              }),
              _c("p", [
                _c("span", [_vm._v(_vm._s(_vm.actData.originAmount))]),
                _vm.actData.discountDesc
                  ? _c("span", [_vm._v("+" + _vm._s(_vm.actData.discountDesc))])
                  : _vm._e(),
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.actData.currency) +
                    _vm._s(_vm.handleDiv100(_vm.actData.originPrice))
                ),
              ]),
            ]),
            _vm._m(0),
            _c("div", { staticClass: "rules-right" }, [
              _c("img", {
                attrs: { src: require("./images/coins-1.png"), alt: "" },
              }),
              _c("p", [_vm._v(_vm._s(_vm.actData.extraAmount))]),
              _c("p", [_vm._v(_vm._s(_vm.$t("lang.coupon.extra")))]),
              _c("img", {
                attrs: { src: require("./images/discount.png"), alt: "" },
              }),
            ]),
          ]),
          _c("img", {
            staticClass: "rules-arrow",
            attrs: { src: require("./images/arrow-down.png"), alt: "" },
          }),
          _c("div", { staticClass: "act-nine-rules act-nine-rules2" }, [
            _c("div", { staticClass: "rules-content" }, [
              _c("div", [
                _c("img", {
                  attrs: { src: require("./images/coins-3.png"), alt: "" },
                }),
                _c("p", [
                  _c("span", [_vm._v(_vm._s(_vm.actData.targetAmount))]),
                  _vm.actData.discountDesc
                    ? _c("span", [
                        _vm._v("+" + _vm._s(_vm.actData.discountDesc)),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.actData.currency) +
                    _vm._s(_vm.handleDiv100(_vm.actData.originPrice))
                ),
              ]),
              _c("div", { staticClass: "coins-total" }, [
                _vm._v(_vm._s(_vm.$t("lang.dl.total"))),
              ]),
            ]),
          ]),
          _vm.apiData
            ? _c(
                "div",
                {
                  staticClass: "top-up-btn",
                  on: {
                    click: function ($event) {
                      if ($event.target !== $event.currentTarget) return null
                      return _vm.handleTopUp.apply(null, arguments)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("lang.recharge.topUp")))]
              )
            : _vm._e(),
          _c("ul", { staticClass: "act-tips" }, [
            _c("li", [_vm._v(_vm._s(_vm.$t("lang.commonM.k060")))]),
            _c("li", [_vm._v("1." + _vm._s(_vm.$t("lang.commonM.k061")))]),
            _c("li", [_vm._v("2." + _vm._s(_vm.$t("lang.commonM.k062")))]),
            _c("li", [_vm._v("3." + _vm._s(_vm.$t("lang.commonM.k063")))]),
          ]),
        ]
      ),
      _c("div", { staticStyle: { height: "30px" } }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rules-center" }, [_c("i", [_vm._v("+")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }